export default __webpack_public_path__ + "static/media/iMac.2d002985.png";